import { LayoutConfig } from 'golden-layout'

/**
 * merge the default layout with the user provided layout
 */
export function mergeDefaultLayout(layout: LayoutConfig): LayoutConfig {
  return {
    ...layout,
    dimensions: {
      ...layout.dimensions,
      borderWidth: 4,
    },
    settings: {
      ...layout.settings,
      showPopoutIcon: false,
    },
    header: {
      ...layout.header,
      maximise: 'maximize',
      minimise: 'minimize',
    },
  }
}

export const DEFAULT_LAYOUT: LayoutConfig = mergeDefaultLayout({
  root: {
    type: 'stack',
    content: [
      {
        type: 'component',
        title: 'Getting Started',
        componentType: 'getting-started-cggjc',
      },
    ],
  },
})
